import React from 'react';

const ProductCards = ({ id, image, title, description, price, originalPrice, onUpdate, quantity }) => {
  // const [quantity, setQuantity] = useState(0);
  // useEffect(()=>{
  //   onUpdate(id, quantity, title, price);

  // },[quantity]);
  const increment = () => {
    onUpdate(id, quantity+1, title, price);
    };
  const decrement = () => {
    if (quantity > 0) 
      {    onUpdate(id, quantity-1, title, price);

      }
    
  };

  return (
    <div className="product-card" >
      <img src={image} loading="lazy" alt={title} className="product-image" />
      
      <div className="product-info">
        <h3>{title}</h3>
        <p>{description}</p>

        <div className="price-tag">
          {/* Only show original price if it exists */}
          {originalPrice && (
            <span className="originalprice">
              Rs {originalPrice}
            </span>
          )}
          <span className='price'>
            Rs {price}
          </span>
        </div>
        
      </div>

      <div className="product-actions">
        <button style={{width:'25%'}} onClick={decrement} disabled={quantity === 0}>-</button>
        <span>{quantity}</span>
        <button style={{width:'25%'}} onClick={increment}>+</button>
      </div>

      
    </div>
  );
};

export default ProductCards;
